import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class API extends Base {
	constructor(props) {
		super(props);
		this.state = {
			refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
			caller: props.Caller,
			controllerName: 'api',
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			data: null,
			loading: true,
			branches: [],
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();
		this.httpPost("api/v1/api/get", {
			id: this.state.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.state.data = data;

					this.httpPost("api/v1/branch/list", { phrase: '', count: 100, page: 1 })
						.then(data => {
							this.state.branches = data.records;
							this.setState({
								loading: false
							});
						});
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	save(e) {
		e.preventDefault();

		this.httpPost("api/v1/api/save", {
			id: this.state.id,
			status: this.state.data.record.status,
			token: this.state.data.record.token,
			branchId: this.state.data.record.branchId,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
					if (this.state.refreshCallerAfterSave)
						this.state.caller.refreshData();
					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<input id="attachFilePicker" type="file" className="hidden" onChange={(e) => { this.uploadAttachment(e.target.files[0]) }} />
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body">
						<div className="modal-header modal-header-info" style={{ "padding": "0" }}>
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">دسترسی API</h4>
						</div>
						<div className="modal-body" style={{ "display": "flex", "flex-direction": "column", "gap": "10px" }}>
							<div className="row">
								<div className="col-sm-10">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">توکن</label>
										<input defaultValue={this.state.data.record.token} disabled="disabled" autocomplete="off" type="text" className="form-control input-smnumber" maxlength="20" />
									</div>
								</div>
								<div className="col-sm-2">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">وضعیت</label>
										<select defaultValue={this.state.data.record.status} onChange={e => this.state.data.record.status = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-smnumber">
											<option value="1">فعال</option>
											<option value="2">غیرفعال</option>
										</select>
									</div>
								</div>
								<div className="col-sm-3">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">شعبه</label>
										<select defaultValue={this.state.data.record.branchId} onChange={e => this.state.data.record.branchId = e.target.value} autocomplete="off" type="text" className="form-control input-smnumber">
											<option value={this.getDefaultGuid()}>کسب و کار اصلی</option>
											{this.state.branches.map(branch =>
												<option value={branch.id}>{branch.name}</option>
											)}
										</select>
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<button type="button" className="hand btn btn-primary" onClick={e => this.save(e)} >ذخیره</button>
							<a className="btn btn-warning" onClick={e => this.closeMe()}>انصراف</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}